/* Shared catalog: values copied from src/data/catalog.ts. Classic script. */
(function () {
  'use strict';
  const AOD = window.AOD = window.AOD || {};
  AOD.asset = function (name) { return (window.AOD_ASSETS || {})[name] || ''; };
  AOD.money = function (cents) {
    const amount = Number(cents);
    const value = Number.isFinite(amount) ? amount : 0;
    const settings = window.AOD_SETTINGS || {};
    if (typeof window.Shopify?.formatMoney === 'function') {
      return String(window.Shopify.formatMoney(value, settings.moneyFormat || '${{amount}}')).replace(/<[^>]*>/g, '');
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: settings.currency || window.Shopify?.currency?.active || 'USD',
        minimumFractionDigits: 2
      }).format(value / 100);
    } catch (_) { return '$' + (value / 100).toFixed(2); }
  };

const garments = {
  crew: {
    key: 'crew', label: 'Crewneck', mockup: AOD.asset('img-mock-crew.webp'), maxWidthIn: 10,
    zones: {
      center: { cx: 500, cy: 335, w: 380, h: 220 },
      left: { cx: 628, cy: 268, w: 140, h: 90 },
      sleeve: { cx: 188, cy: 806, w: 140, h: 42 }, // horizontal, just above the cuff
    },
  },
  hoodie: {
    key: 'hoodie', label: 'Hoodie', mockup: AOD.asset('img-mock-hoodie.webp'), maxWidthIn: 10,
    zones: {
      center: { cx: 505, cy: 470, w: 320, h: 170 },
      left: { cx: 615, cy: 420, w: 120, h: 80 },
      sleeve: { cx: 215, cy: 650, w: 260, h: 42, rot: -84 },
    },
  },
  tee: {
    key: 'tee', label: 'T-Shirt', mockup: AOD.asset('img-mock-tee.webp'), maxWidthIn: 10,
    zones: {
      center: { cx: 505, cy: 330, w: 380, h: 220 },
      left: { cx: 630, cy: 262, w: 130, h: 85 },
    },
  },
  onesie: {
    key: 'onesie', label: 'Bodysuit', mockup: AOD.asset('img-mock-onesie.webp'), maxWidthIn: 5,
    zones: {
      center: { cx: 505, cy: 360, w: 300, h: 180 },
      left: { cx: 590, cy: 300, w: 110, h: 70 },
    },
  },
  cap: {
    key: 'cap', label: 'Dad Cap', mockup: AOD.asset('img-mock-cap.webp'), maxWidthIn: 4,
    zones: { front: { cx: 470, cy: 420, w: 260, h: 140 } },
  },
  tote: {
    key: 'tote', label: 'Tote', mockup: AOD.asset('img-mock-tote.webp'), maxWidthIn: 9,
    zones: { center: { cx: 512, cy: 640, w: 380, h: 300 } },
  },
  tank: {
    key: 'tank', label: 'Tank top', mockup: AOD.asset('img-mock-tank.webp'), maxWidthIn: 8,
    zones: { center: { cx: 500, cy: 440, w: 300, h: 170 } },
  },
  set: {
    key: 'set', label: 'Lounge set', mockup: AOD.asset('img-mock-set.webp'), maxWidthIn: 8,
    zones: { center: { cx: 500, cy: 335, w: 240, h: 130 } },
  },
  box: {
    key: 'box', label: 'Gift box', mockup: AOD.asset('img-mock-box.webp'), maxWidthIn: 8,
    zones: { front: { cx: 500, cy: 480, w: 540, h: 290 } },
  },
  pouch: {
    key: 'pouch', label: 'Pouch', mockup: AOD.asset('img-mock-pouch.webp'), maxWidthIn: 6,
    zones: { front: { cx: 500, cy: 535, w: 540, h: 290 } },
  },
  socks: {
    key: 'socks', label: 'Socks', mockup: AOD.asset('img-mock-socks.webp'), maxWidthIn: 3,
    zones: { front: { cx: 365, cy: 380, w: 160, h: 100 } },
  },
  napkin: {
    key: 'napkin', label: 'Cocktail napkin', mockup: AOD.asset('img-mock-napkin.webp'), maxWidthIn: 4,
    zones: { front: { cx: 500, cy: 500, w: 440, h: 240 }, corner: { cx: 735, cy: 735, w: 220, h: 110 } },
  },
  headband: {
    key: 'headband', label: 'Headband', mockup: AOD.asset('img-mock-headband.webp'), maxWidthIn: 4,
    zones: { front: { cx: 480, cy: 500, w: 560, h: 100 } },
  },
};

// Product photography keeps its own colours; zones are tuned after assets land.
const productBases = {
  'accessory-zebra-cosmetic-pouch': { mockup: AOD.asset('img-base-zebra-pouch.webp'), tint: false, colors: { whitestripe: AOD.asset('img-base-zebra-pouch-white.webp') }, zones: { front: { cx: 500, cy: 508, w: 415, h: 141 } } },
  'accessory-fawn-faux-fur-cosmetic-pouch': { mockup: AOD.asset('img-base-fawn-pouch.webp'), tint: false, zones: { front: { cx: 493, cy: 495, w: 427, h: 145 } } },
  'accessory-croc-travel-pouch': { mockup: AOD.asset('img-base-croc-pouch.webp'), tint: false, colors: { black: AOD.asset('img-base-croc-pouch-black.webp'), red: AOD.asset('img-base-croc-pouch-red.webp'), burgundy: AOD.asset('img-base-croc-pouch-burgundy.webp'), burgndy: AOD.asset('img-base-croc-pouch-burgundy.webp') }, zones: { front: { cx: 494, cy: 518, w: 416, h: 139 } } },
  'accessory-bamboo-blend-ruffle-crew-socks': { mockup: AOD.asset('img-base-socks.webp'), tint: false, thread: '1967', zones: { front: { cx: 420, cy: 287, w: 219, h: 117 } } },
  'accessory-mini-boat-tote-bag': { mockup: AOD.asset('img-base-mini-boat-tote.webp'), tint: true, zones: { front: { cx: 499, cy: 430, w: 300, h: 110 } } },
  'accessory-mini-aod-tote-bag': { mockup: AOD.asset('img-base-mini-aod-tote.webp'), tint: true, zones: { front: { cx: 496, cy: 470, w: 300, h: 110 } } },
};

const placementLabels = {
  center: 'Center chest',
  left: 'Left chest',
  sleeve: 'Sleeve',
  front: 'Front panel',
  corner: 'Corner',
};

const garmentColors = {
  white: { name: 'White', hex: '#FFFFFF' },
  cream: { name: 'Cream', hex: '#F2EADB' },
  sand: { name: 'Sand', hex: '#D9C7AC' },
  oatmeal: { name: 'Oatmeal', hex: '#E3D8C6' },
  ash: { name: 'Ash', hex: '#DCDBD7' },
  sport: { name: 'Sport Grey', hex: '#A9A9A6' },
  charcoal: { name: 'Charcoal', hex: '#4C4C4E' },
  black: { name: 'Black', hex: '#2A2A2C' },
  navy: { name: 'Navy', hex: '#28324A' },
  indigo: { name: 'Indigo Blue', hex: '#55708C' },
  carolina: { name: 'Carolina Blue', hex: '#8DB1DE' },
  lightblue: { name: 'Light Blue', hex: '#BBD0E6' },
  sage: { name: 'Sage', hex: '#B7C3A6' },
  military: { name: 'Military Green', hex: '#66704F' },
  forest: { name: 'Forest', hex: '#2F4B3B' },
  lightpink: { name: 'Light Pink', hex: '#F2CCD6' },
  blush: { name: 'Blush Pink', hex: '#E8B9B1' },
  lavender: { name: 'Lavender', hex: '#C9BBE2' },
  butter: { name: 'Butter', hex: '#F3E2A0' },
  maroon: { name: 'Maroon', hex: '#5C2232' },
  cardinal: { name: 'Cardinal', hex: '#8B2130' },
  chocolate: { name: 'Chocolate', hex: '#4F3A2E' },
  natural: { name: 'Natural', hex: '#EFE6D2' },
  grey: { name: 'Grey', hex: '#B4B4B3' },
  athleticheather: { name: 'Athletic Heather', hex: '#C9C9C8' },
  babyblue: { name: 'Baby Blue', hex: '#B8D3EA' },
  brown: { name: 'Brown', hex: '#6B4A36' },
  denim: { name: 'Denim', hex: '#5A7794' },
  pink: { name: 'Pink', hex: '#F0B8C8' },
  red: { name: 'Red', hex: '#B3202D' },
  coralpink: { name: 'Coral Pink', hex: '#F08A80' },
  green: { name: 'Green', hex: '#4C8A5B' },
  orange: { name: 'Orange', hex: '#E8803A' },
  powderpink: { name: 'Powder Pink', hex: '#F5D5DC' },
  safari: { name: 'Safari', hex: '#B9A77E' },
  tealgreen: { name: 'Teal Green', hex: '#2F7F78' },
  beige: { name: 'Beige', hex: '#DDCDB2' },
  blue: { name: 'Blue', hex: '#4A74B8' },
  purple: { name: 'Purple', hex: '#7B5BA6' },
  rosered: { name: 'Rose Red', hex: '#C23B5A' },
  burgundy: { name: 'Burgundy', hex: '#6D1F31' },
  burgndy: { name: 'Burgndy', hex: '#6D1F31' },
};

const threads = [
  { code: '1801', name: 'White', hex: '#F7F6F2' },
  { code: '1230', name: 'Root Beer', hex: '#503E29' },
  { code: '1328', name: 'Buckskin Beige', hex: '#A58970' },
  { code: '1149', name: 'Tusk Beige', hex: '#EAD5BC' },
  { code: '1086', name: 'Silver', hex: '#C1C1C3' },
  { code: '1800', name: 'Black', hex: '#1F1E21' },
  { code: '1065', name: 'Orange', hex: '#EE8104' },
  { code: '1025', name: 'Military Gold', hex: '#D69C04' },
  { code: '1392', name: 'Sage Green', hex: '#6E7964' },
  { code: '1103', name: 'Hunter Green', hex: '#354836' },
  { code: '1956', name: 'Olive Green', hex: '#776F33' },
  { code: '1900', name: 'Celadon Green', hex: '#B3C7A2' },
  { code: '1297', name: 'Calypso Blue', hex: '#0672D8' },
  { code: '1967', name: 'Navy Blue', hex: '#181828' },
  { code: '1094', name: 'Caribbean Blue', hex: '#69BBDD' },
  { code: '1132', name: 'Clear Blue', hex: '#B7CDE5' },
  { code: '1033', name: 'Purple Pansy', hex: '#67388A' },
  { code: '1111', name: 'Mist Purple', hex: '#CBAECE' },
  { code: '1037', name: 'Tango Red', hex: '#A1030D' },
  { code: '1385', name: 'Garnet', hex: '#450B1F' },
  { code: '1108', name: 'Pink Carnation', hex: '#FF91AB' },
  { code: '1309', name: 'Dahlia Pink', hex: '#D75BAA' },
  { code: '1383', name: 'Pink Pansy', hex: '#790238' },
  { code: '1120', name: 'Baby Pink', hex: '#F4D5DB' },
];

const fonts = [
  { id: 'script', label: 'Classic Script', family: "'Dancing Script', cursive", weight: 700, sample: 'mama' },
  { id: 'signature', label: 'Signature', family: "'Parisienne', cursive", weight: 400, sample: 'Mrs. Ellis' },
  { id: 'retro', label: 'Retro', family: "'Pacifico', cursive", weight: 400, sample: 'Sunday' },
  { id: 'varsity', label: 'Varsity', family: "'Graduate', serif", weight: 400, sample: 'TEXAS' },
  { id: 'serif', label: 'Editorial Serif', family: "'Playfair Display', serif", weight: 600, sample: 'Amour' },
  { id: 'rounded', label: 'Rounded', family: "'Fredoka', sans-serif", weight: 600, sample: 'Leo' },
  { id: 'block', label: 'Bold Block', family: "'Archivo Black', sans-serif", weight: 400, sample: 'CREW' },
  { id: 'type', label: 'Typewriter', family: "'Courier Prime', monospace", weight: 700, sample: 'est. 2025' },
];

const addOns = {
  sleeve: { label: 'Add sleeve text', price: 8 },
  digitizing: { label: 'Logo digitizing (one-time)', price: 15 },
  metallic: { label: 'Metallic thread', price: 5 },
  rush: { label: 'Rush production', price: 12 },
  gift: { label: 'Gift wrap + handwritten note', price: 5 },
};

const bulkTiers = [
  { min: 1, off: 0 },
  { min: 15, off: 10 },
];

  AOD.catalog = { garments, garmentColors, threads, fonts, addOns, bulkTiers, placementLabels, productBases };
})();
